// extracted by mini-css-extract-plugin
var _1 = "appLoadingPage-Vp7f";
var _2 = "#007ac9";
var _3 = "#575757";
var _4 = "1.5rem";
var _5 = "#dedede";
var _6 = "#adf";
var _7 = "1rem";
var _8 = "#bebebe";
var _9 = "messageContainer-Djcj";
var _a = ".8rem";
var _b = "#000";
export { _1 as "appLoadingPage", _2 as "busBlue", _3 as "darkGrey", _4 as "extraLargeFontSize", _5 as "lightGrey", _6 as "lightblue", _7 as "mediumFontSize", _8 as "mediumLightGrey", _9 as "messageContainer", _a as "smallFontSize", _b as "unusedNodeColor" }
